<template>
  <div class="bannerBox">
    <a-carousel :dot-position="bottom">
      <div>
        <img class="bannerImg" src="@/assets/img/scjr-tzr.jpg" />
      </div>
    </a-carousel>
  </div>
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
      <router-view />
    </div>
  </div>
</template>
<script>

export default {
  name: 'investor',
  props: {
  },
  mounted() {
    console.log(this.$route.query.type)
    this.title = this.$route.query.type
    this.$parent.clearHeadFun()
  },
  data() {
    return {
      title: '',

    }
  },
  methods: {
    goMore(url, key) {
      this.$router.push({
        path: url,
        query: { type: key }
      })
      this.$parent.$parent.clearHeadFun()
    },
    backhome() {
      this.goMore('/finance/index', '首页')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../css/components.less";

.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.list_cont {
  width: 592px;
  margin-bottom: 16px;

  &:nth-child(odd) {
    margin-right: 16px;
  }

  .list_img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #eeeeee;
    margin: 20px 10px 20px 25px;
    flex: 1;
  }

  .list_cont_body {
    flex: 5;
  }
}
</style>